import React from 'react';
function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = Number(((millis % 60000) / 1000).toFixed(0));
    return (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}
var PurchaseTimerCountDown = function (_a) {
    var timeLeft = _a.timeLeft;
    if (timeLeft <= 0)
        return null;
    return React.createElement("div", null,
        millisToMinutesAndSeconds(timeLeft),
        " mins");
};
export default PurchaseTimerCountDown;
